import Cursor from './assets/cursor.svg';

import Popper from '@material-ui/core/Popper';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { css, createGlobalStyle } from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  position: relative;

  @media (max-width: 768px) {
    display: none;
  }
`;

/**
 * Estilização do componente ToolOptions
 */
export const ToolOptions = styled(Popper)`
  display: flex;
  position: absolute;
  bottom: -65px;
  background: ${({ theme }) => theme.primaryColorDark};
  min-width: 100px;
  height: 40px;
  z-index: 400;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5) inset;
  padding: 0 15px;

  hr {
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    margin: 0 10px;
    height: 100%;
  }
`;

/**
 * Estilização do componente ModalBody
 */
export const ModalBody = styled.div`
  padding-top: 32px;
  p {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    color: #5e6366;
  }

  .MuiButton-root {
    background: #3c71dd;
    border-radius: 3px;
    width: 185.14px;
    height: 40px;
  }

  .MuiButton-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #ffffff;
    text-transform: none;
  }
`;

/**
 * Estilização do componente ChangeCursor
 */
export const ChangeCursor = createGlobalStyle`
  #map, .leaflet-interactive {
    cursor: url(${Cursor}) 13 12, auto !important;    
  }
`;

/**
 * Estilização do componente TextareaFont
 */
const TextareaFont = css`
  font-family: Roboto;
  font-weight: 400;
  font-size: 12px;
  line-height: 11.72px;
`;

/**
 * Estilização do componente InsertTextareaGb
 */
export const InsertTextareaGb = createGlobalStyle`  

  .insertTextareaGb {    
    ${TextareaFont};
    background: rgba(255, 255, 255, 0.7);    
    padding-left: 6px;
    padding-right: 6px;
    border: dashed 2px #3C71DD !important;
    min-width: 25px;
    cursor: text;

    &:not(:focus){
      border: dashed 1px #3C71DD !important;
    } 
  }

  .markerTextAreaGb {
    ${TextareaFont};
    font-family: Roboto;
    font-weight: 400;
    font-size: 12px;
    line-height: 11.72px;
    color: #fff;
    text-shadow: -1px 0 0 #000, -1px -1px 0 #000, 0 -1px 0 #000, 1px -1px 0 #000, 1px 0 0 #000, 1px 1px 0 #000, 0 1px 0 #000, -1px 1px 0 #000;
    background: rgba(255, 255, 255, 0);
    cursor: default;
  }
`;
